/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_KeyboardInputs */

const en_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keyboard navigation on all pages`)
};

const de_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastaturnavigation auf allen Seiten`)
};

const fr_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigation au clavier sur toutes les pages`)
};

const es_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegacion por teclado en todas las paginas`)
};

const it_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigazione da tastiera su tutte le pagine`)
};

const nl_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toetsenbordnavigatie op alle pagina's`)
};

const pl_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nawigacja klawiaturowa na wszystkich stronach`)
};

const fi_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näppaimistonavigaatio kaikilla sivuilla`)
};

const da_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastaturnavigation pa alle sider`)
};

const sv_a11y_statement_accessible_keyboard = /** @type {(inputs: A11y_Statement_Accessible_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tangentbordsnavigering pa alla sidor`)
};

/**
* | output |
* | --- |
* | "Keyboard navigation on all pages" |
*
* @param {A11y_Statement_Accessible_KeyboardInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_keyboard = /** @type {((inputs?: A11y_Statement_Accessible_KeyboardInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_KeyboardInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_keyboard(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_keyboard(inputs)
	if (locale === "es") return es_a11y_statement_accessible_keyboard(inputs)
	if (locale === "it") return it_a11y_statement_accessible_keyboard(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_keyboard(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_keyboard(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_keyboard(inputs)
	if (locale === "da") return da_a11y_statement_accessible_keyboard(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_keyboard(inputs)
	return en_a11y_statement_accessible_keyboard(inputs)
});